import moment from "moment";

export const getInitials = (name) => {
 if (typeof name !== "string" || !name.trim()) return null;

  const nameParts = name.trim().split(" ");
  if (nameParts) {
    const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
    return initials.toUpperCase();
  } else {
    return nameParts[0][0].toUpperCase();
  }
};

export const formatDate = (date, format = "DD-MM-YYYY hh:mm A") => {
  if (!date || !moment(date).isValid()) return null;
  return moment(date).format(format);
};
